(function () {
  'use strict';

  // Backend that creates the order + IutePay session. Edit here if it ever changes.
  var BACKEND_URL = 'https://iutepay.eurovizif.mk';

  var pendingTrigger = null; // the button that opened the modal (product vs cart mode)

  function getModal() { return document.getElementById('iutepay-modal'); }

  // Theme sections may render the modal more than once or inside a clipped/transformed
  // container. Keep exactly one copy and attach it straight to <body>.
  function prepareModal() {
    var all = document.querySelectorAll('#iutepay-modal');
    for (var i = 1; i < all.length; i++) all[i].parentNode.removeChild(all[i]);
    var m = all[0];
    if (m && m.parentNode !== document.body) document.body.appendChild(m);
    return m;
  }

  function openModal(trigger) {
    var modal = prepareModal();
    if (!modal) { console.error('[IutePay] modal markup not found on page'); return; }
    pendingTrigger = trigger;
    var errorEl = modal.querySelector('[data-iutepay-error]');
    if (errorEl) errorEl.hidden = true;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = getModal();
    if (modal) modal.hidden = true;
    document.body.style.overflow = '';
  }

  // Event delegation: works even if the theme re-renders the button area.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-iutepay-trigger]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger);
      return;
    }
    if (e.target.closest && e.target.closest('[data-iutepay-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function showError(message) {
    var modal = getModal();
    var errorEl = modal && modal.querySelector('[data-iutepay-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function absUrl(u) {
    if (!u) return undefined;
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return window.location.origin + u;
    return u;
  }

  /**
   * Build the payload for "buy this product now" from the product page.
   * Reads the CURRENTLY selected variant + quantity from the page's main product form and
   * loads authoritative product data from Shopify (/products/<handle>.js), so it stays correct
   * after the visitor changes variant/color or picks a quantity pack.
   */
  function itemsFromProductButton(btn) {
    var handle = '';
    try { handle = new URL(btn.getAttribute('data-url')).pathname.split('/products/')[1].split('/')[0]; } catch (e) {}

    var idInput = document.querySelector('form[id^="product-form-"] input[name="id"]');
    var variantId = Number((idInput && idInput.value) || btn.getAttribute('data-variant-id'));

    var qtyInput =
      document.querySelector('input[name="quantity"][form^="product-form-"]') ||
      document.querySelector('form[id^="product-form-"] input[name="quantity"]');
    var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

    function fallback() {
      return {
        items: [{
          variantId: variantId,
          sku: btn.getAttribute('data-sku'),
          title: btn.getAttribute('data-title'),
          unitPrice: Number(btn.getAttribute('data-price')),
          quantity: quantity,
          imageUrl: absUrl(btn.getAttribute('data-image')),
          url: btn.getAttribute('data-url'),
        }],
        shippingAmount: 0,
        taxAmount: 0,
      };
    }
    if (!handle) return Promise.resolve(fallback());

    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var v = (product.variants || []).filter(function (x) { return x.id === variantId; })[0];
        if (!v) return fallback();
        var img = (v.featured_image && v.featured_image.src) || product.featured_image;
        return {
          items: [{
            variantId: v.id,
            sku: v.sku || String(v.id),
            title: product.title,
            unitPrice: v.price / 100,
            quantity: quantity,
            imageUrl: absUrl(img),
            url: window.location.origin + '/products/' + handle + '?variant=' + v.id,
          }],
          shippingAmount: 0,
          taxAmount: 0,
        };
      })
      .catch(fallback);
  }

  /** Build the { items, ... } payload for the cart page by reading Shopify's Ajax /cart.js. */
  function itemsFromCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          throw new Error('Вашата кошничка е празна.');
        }
        return {
          items: cart.items.map(function (li) {
            return {
              variantId: li.variant_id,
              sku: li.sku,
              title: li.product_title,
              unitPrice: li.price / 100,
              quantity: li.quantity,
              imageUrl: absUrl(li.image),
              url: window.location.origin + li.url,
            };
          }),
          shippingAmount: 0,
          taxAmount: 0,
        };
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'iutepay-form') return;
    e.preventDefault();
    var modal = getModal();
    var errorEl = modal.querySelector('[data-iutepay-error]');
    errorEl.hidden = true;

    var fd = new FormData(form);
    var customer = {
      firstName: fd.get('firstName'),
      lastName: fd.get('lastName'),
      email: fd.get('email'),
      phone: fd.get('phone'),
      address: {
        line1: fd.get('line1'),
        line2: fd.get('line2'),
        city: fd.get('city'),
        zip: fd.get('zip'),
        country: fd.get('country'),
      },
    };

    var submitBtn = form.querySelector('.iutepay-buy-btn--submit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Ве молиме почекајте…';

    var mode = pendingTrigger && pendingTrigger.getAttribute('data-iutepay-mode');
    var itemsPromise = mode === 'cart' ? itemsFromCart() : Promise.resolve(itemsFromProductButton(pendingTrigger));

    itemsPromise
      .then(function (payload) {
        payload.customer = customer;
        return fetch(BACKEND_URL + '/api/iutepay/checkout', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.error || 'Грешка'); });
        return res.json();
      })
      .then(function (data) {
        window.location.href = data.redirectUrl;
      })
      .catch(function (err) {
        showError(err.message || 'Настана грешка. Обидете се повторно.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Продолжи кон IutePay';
      });
  });
})();